import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SpinnerState {
    show: boolean;
    text?: string;
}

/**
 * Estado global del spinner (`app-spinner`).
 *
 * Usa un contador en lugar de un booleano para soportar operaciones
 * concurrentes: el spinner se oculta recién cuando no queda ninguna activa.
 */
@Injectable({ providedIn: 'root' })
export class SpinnerService {

    private count = 0;
    private readonly state$ = new BehaviorSubject<SpinnerState>({ show: false });

    readonly spinner$: Observable<SpinnerState> = this.state$.asObservable();

    show(text?: string): void {
        this.count++;
        this.state$.next({ show: true, text });
    }

    hide(): void {
        this.count = Math.max(0, this.count - 1);
        if (this.count === 0) {
            this.state$.next({ show: false });
        }
    }

    /**
     * Ejecuta `fn` mostrando el spinner y garantiza el `hide()` aunque falle.
     */
    async withLoading<T>(fn: () => Promise<T>, text?: string): Promise<T> {
        this.show(text);
        try {
            return await fn();
        } finally {
            this.hide();
        }
    }
}
